import { Component, OnInit } from '@angular/core';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { FomCheckService } from 'src/app/services/fom-check.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-fom-check',
  templateUrl: './fom-check.component.html',
  styleUrls: ['./fom-check.component.scss'],
  standalone: false
})
export class FomCheckComponent implements OnInit {

  constructor(public fomCheckService : FomCheckService,
     public menuController : MenuManagementService,
     public tabsService : TabsService) { }

  ngOnInit(): void {
  }

  cancel(): void{
    this.fomCheckService.active = false;
  }

}
